/* eslint-disable */
export default {
  noResultFoundFor: '次の結果が見つかりませんでした：',
  foundFromServerHint:
    '{appName}でキーワードを入力し、Enterキーを押して検索します',
  notResultFoundFromServer: '結果が見つかりません',
  loading: '読み込み中...',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
